<template>
  <el-container class="outer-container">
    <el-header class="outheader">
      <TopHeader>
      </TopHeader>
    </el-header>
    <el-container class="inner-container">
      <el-aside class="inner-aside"
                style="width: auto">
        <AsideMenue v-if="userLoaded">
        </AsideMenue>
      </el-aside>
      <el-container class="inner-container2">
        <!-- <HeadProduct v-if="!$store.state.user.loginInfo.is_partner"></HeadProduct> -->
        <div v-if="isShowTip"
             class="headMsgBox"
             v-html="msg"></div>
        <el-main>
          <el-scrollbar style="height:100%;scroll-behavior:smooth;"
                        ref="scrollbar">
            <el-header class="header">
              <MainHeader v-if="showMainHeader && userLoaded">
              </MainHeader>
            </el-header>
            <router-view class="roterView"
                         v-if="userLoaded&&showView" />
            <Footer v-if="showFoot"
                    style="height: 190px"></Footer>
          </el-scrollbar>
        </el-main>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
import TopHeader from '@/components/topHeader.vue'
import MainHeader from '@/components/mainHeader.vue'
import AsideMenue from '@/components/AsideMenue.vue'
import Footer from '@/components/footer.vue'
// import HeadProduct from '@/components/headProduct.vue'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import { getServerStatus } from '@/api/user'
export default {
  components: {
    TopHeader,
    MainHeader,
    AsideMenue,
    Footer,
    // HeadProduct,
  },
  data() {
    return {
      showView: true,
      hasScrolledToTopOnce: false,
      isShowTip: false,
      msg: '',
    }
  },
  mounted() {
    this.$eventBus.$on('TopScroll', () => {
      if (this.$refs.scrollbar) {
        this.$refs.scrollbar.wrap.scrollTop = 0
      }
    })
    this.$eventBus.$on('refreshView', this.refreshView)
    this.$eventBus.$on('routerViewScroll', (val) => {
      if (this.$refs.scrollbar) {
        // this.$refs.scrollbar.wrap.scrollTop = val
        this.$refs.scrollbar.wrap.scrollTo({
          top: val,
          behavior: 'smooth', // 启用平滑滚动
        })
      }
    })

    // this.$refs.scrollbar.wrap.addEventListener('scroll', this.handleScroll)
  },
  computed: {
    showMainHeader() {
      return this.$store.state.user.ShowMainHead
    },
    userLoaded() {
      return this.$store.state.user.userLoaded
    },
    showFoot() {
      let isShow = false
      if (Object.keys(this.$store.state.user.loginInfo).length > 0) {
        if (this.$store.state.user.loginInfo.is_partner) {
          isShow = false
        } else {
          isShow = true
        }
      }
      return isShow
    },
  },
  async created() {
    const browserFinger = localStorage.getItem('browserFinger')
    if (!browserFinger) {
      const fpPromise = FingerprintJS.load()
      const fp = await fpPromise
      const result = await fp.get()
      localStorage.setItem('browserFinger', result.visitorId)
    }
    this.getServer()
  },
  methods: {
    refreshView() {
      this.showView = false
      this.$nextTick(() => {
        this.showView = true
      })
    },
    changeShowChatBot() {
      this.$store.dispatch(
        'user/changeShowChatBot',
        !this.$store.state.user.showChatBot
      )
    },
    handleScroll() {
      const top = this.$refs.scrollbar.wrap.scrollTop

      if (top > 1) {
        this.$eventBus.$emit('showNavCrumb', true)
        this.hasScrolledToTopOnce = false
      } else {
        if (top == 0) {
          if (this.hasScrolledToTopOnce) {
            this.$eventBus.$emit('showNavCrumb', false)
          } else {
            // console.log(
            //   this.$refs.scrollbar.wrap.scrollTop,
            //   'this.$refs.scrollbar.wrap.scrollTop'
            // )
            this.$refs.scrollbar.wrap.scrollTop = 1
            setTimeout(() => {
              this.hasScrolledToTopOnce = true
            }, 700)
          }
        }
      }

      const selectDropdowns = document.querySelectorAll(
        '.el-select-dropdown.el-popper'
      )
      selectDropdowns.forEach((dropdown) => {
        if (dropdown.style.display !== 'none') {
          // 触发关闭事件
          const select = dropdown.__vue__.$parent
          if (select.visible) {
            select.visible = false
          }
        }
      })
    },
    getServer() {
      getServerStatus()
        .then((res) => {
          if (res.status == 'ok') {
            let msgArr = res.result
            if (Object.prototype.toString.call(msgArr) === '[object Array]') {
              let str = ''
              for (let i = 0; i < msgArr.length; i++) {
                if (msgArr[i].status == 1 || msgArr[i].status == 2) {
                  str +=
                    '<div style="color:inherit">' + msgArr[i].msg + '</div>'
                }
              }
              if (str != '') {
                this.msg = str
                this.isShowTip = true
              }
            }
            // if (res.result.status == 1 || res.result.status == 2) {
            //   this.msg = res.result.msg
            //   this.isShowTip = true
            // }
          } else {
            this.$message.error('请求失败')
          }
        })
        .catch((e) => {
          this.isShowTip = false
          // this.$message.success('请求失败')
        })
    },
  },
  beforeDestroyed() {
    this.$eventBus.$off('refreshView')
  },
}
</script>

<style scoped lang="less">
.headMsgBox {
  font-size: 14px;
  padding: 15px;
  background-color: #fcf8e3;
  border-color: #faebcc;
  color: #8a6d3b;
  width: 100%;
}
.outer-container {
  height: 100%;
  .outheader {
    min-height: 60px;
    height: auto !important;
    // z-index: 9999;
    background-color: #fff;
    box-shadow: 0 2px 5px 0 rgba(159, 77, 0, 0.2);
    border-radius: 0 0 4px 4px;
  }
  .inner-container {
    height: calc(100% - 60px);
    .inner-container2 {
      height: 100%;
      display: block;
      .el-main {
        background-color: #f3f4f6;
        height: 100%;
        overflow: auto;
        padding: 0px;
      }
      .header {
        // z-index: 9999;
        // position: relative;
        background-color: #f3f4f6;
        /deep/ .header-one {
          z-index: 999;
          position: relative;
        }
      }
    }
  }
}
.header {
  padding: 0;
  height: auto !important;
  background: #f3f4f6;
}
.roterView {
  /deep/ .el-loading-mask {
    z-index: 9;
  }
}
</style>
